const createPayload = (filterValues) => ({ filters: filterValues });

const matchesPathSegment = (value, segment) => {
    const urlValue = (value || '').toLowerCase().split('/');
    const returnedValue = urlValue.includes(segment.toLowerCase());

    return returnedValue;
};

const hasSecurityRoute = (value) => {
    return matchesPathSegment(value, 'security') || matchesPathSegment(value, 'dashboardsecurity');
};

const shouldEnableQuery = (queryConfig, filters, enabled) => {
    const normalizedUrl = queryConfig?.url || '';
    const normalizedKey = queryConfig?.key || '';

    const enableRules = [
        () => !!filters?.year,
        () => normalizedUrl.includes('unifiedregistry'),
        () => normalizedUrl.includes('vitalstatistics'),
        () => normalizedUrl.includes('dashboardsamu'),
        () => normalizedUrl.includes('igd'),
        () => normalizedUrl.includes('socialAssistanceSurveillance'),
        () => hasSecurityRoute(normalizedUrl),
        () => normalizedUrl.includes('cadUn'),
        () => normalizedKey.includes('arrestsmade'),
        () => normalizedUrl.includes('art173eca'),
        () => normalizedKey.includes('police-intervention-deaths'),
        () => normalizedUrl.includes('productivityData'),
        () => normalizedUrl.includes('vehicles'),
        () => normalizedUrl.includes('phones'),
        () => normalizedUrl.includes('objects'),
        () => normalizedUrl.includes('benefits'),
        () => normalizedUrl.includes('criminalData')
    ];

    return enableRules.some((rule) => rule()) && enabled && queryConfig?.enabled !== false;
};

// Função para simplicar a adição de novos filtros dependendo do endpoint, sem precisar criar um if/else gigante
const buildRequestFilters = (queryConfig, filters, city) => {
    const normalizedUrl = queryConfig?.url || '';
    const normalizedKey = queryConfig?.key || '';

    const filterRules = [
        {
            test: (url) => url.includes('sihsus'),
            build: () => {
                // Array = todas as unidades da cidade (allCityUnits), filtra por CNES e não por residência
                if (Array.isArray(filters.location)) {
                    return createPayload({
                        mes_competencia: filters.month,
                        ano_competencia: filters.year,
                        munic_res: '',
                        cnes: filters.location
                    });
                }

                const unit = String(filters.location ?? '');
                const hasUnit = unit !== '' && !unit.includes(',');

                return createPayload({
                    mes_competencia: filters.month,
                    ano_competencia: filters.year,
                    munic_res: !hasUnit && city ? city.slice(0, -1) : '',
                    cnes: hasUnit ? unit : ''
                });
            }
        },
        {
            test: (url) => url.includes('dashboardsamu'),
            build: () => createPayload({
                ano: filters.ano,
                mes: filters.mes,
                city_id: city
            })
        },
        {
            test: (url) => url.includes('unifiedregistry'),
            build: () => createPayload({
                cod_centro_assist_fam: filters.location,
                cd_ibge: city
            })
        },
        {
            test: (url) => url.includes('vitalstatistics'),
            build: () => createPayload({
                data_inicio: filters.data_inicio,
                data_fim: filters.data_fim,
                co_ibge_residencia: filters.location,
                co_ibge: city
            })
        },
        {
            test: (url) => url.includes('igd'),
            build: () => createPayload({
                year: filters.year,
                month: filters.month,
                codigo_ibge: city ? city.slice(0, -1) : ''
            })
        },
        {
            test: (url) => url.includes('values'),
            build: () => createPayload({
                year: filters?.year?.value ?? filters?.year ?? '',
                month: filters?.month?.value ?? filters?.month ?? '',
                codigo_ibge: city ? city.slice(0, -1) : ''
            })
        },
        {
            test: (url) => url.includes('otherBenefits'),
            build: () => createPayload({
                year: filters.year,
                month: filters.month,
                codigo_ibge: city ? city.slice(0, -1) : ''
            })
        },
        {
            test: (url) => url.includes('familyAllowanceTransferValues'),
            build: () => createPayload({
                year: filters?.year?.value ?? filters?.year ?? '',
                month: filters?.month?.value ?? filters?.month ?? '',
                codigo_ibge: city ? city.slice(0, -1) : '',
                codigo_municipio_siafi: filters?.siafi_code?.value ?? filters?.siafi_code ?? ''
            })
        },
        {
            test: (url) => url.includes('benefits'),
            build: () => createPayload({
                ano_competencia: filters.year,
                mes_competencia: filters.month,
                codigo_ibge: city ? city.slice(0, -1) : '',
                codigo_municipio_siafi: filters?.siafi_code?.value ?? filters?.siafi_code ?? '',
                siafi_code: filters?.siafi_code?.value ?? filters?.siafi_code ?? ''
            })
        },
        {
            test: (url) => url.includes('socialAssistanceSurveillance'),
            build: () => createPayload({
                codigo_ibge: city ? city.slice(0, -1) : ''
            })
        },
        {
            test: (url) => url.includes('art173eca'),
            build: () => createPayload({
                ano_competencia: filters?.year ? String(filters.year) : '',
                mes_estatistica: filters?.month ? String(filters.month) : '',
                codigo_ibge: city
            })
        },
        {
            test: (url) => url.includes('deathsByPoliceIntervention'),
            build: () => createPayload({
                ano_estatistica: filters?.year ? String(filters.year) : '',
                mes_estatistica: filters?.month ? String(filters.month) : '',
                codigo_ibge: city
            })
        },
        {
            test: (url) => url.includes('productivityData'),
            build: () => createPayload({
                codigo_ibge: city,
                ano_competencia: filters.year,
                mes_estatistica: filters.month,
            })
        },
        {
            test: (url) => url.includes('vehicles') || url.includes('phones') || url.includes('objects'),
            build: () => createPayload({
                ano_registro_bo: filters.year,
                mes_registro_bo: filters.month,
                codigo_ibge: city
            })
        },
        {
            test: (_, key) => key.includes('arrestsmade'),
            build: () => createPayload({
                ano_competencia: filters?.year ? String(filters.year) : '',
                mes_estatistica: filters?.month ? String(filters.month) : '',
                codigo_ibge: city
            })
        },
        {
            test: (url) => matchesPathSegment(url, 'iml'),
            build: () => createPayload({
                ano_competencia: filters?.year ? String(filters.year) : '',
                mes_competencia: filters?.month ? String(filters.month) : '',
                codigo_ibge: city
            })
        },
        {
            test: (url) => hasSecurityRoute(url),
            build: () => createPayload({
                codigo_ibge: city,
                ano_estatistica: filters.year,
                mes_estatistica: filters.month,
            })
        },
        {
            test: (url) => url.includes('cadUn'),
            build: () => createPayload({
                year: filters.year,
                month: filters.month,
                codigo_ibge: city ? city.slice(0, -1) : ''
            })
        },
                {
            test: (url) => url.includes('criminalData'),
            build: () => createPayload({
                ano_estatistica: filters.year,
                mes_estatistica: filters.month,
                codigo_ibge: city
            })
        }
    ];

    const matchingRule = filterRules.find(({ test }) => test(normalizedUrl, normalizedKey));

    return matchingRule
        ? matchingRule.build(filters, city)
        : createPayload({
            mes_competencia: filters.month,
            ano_competencia: filters.year,
            // "Todos" explícito chega como "cnes1,cnes2,..." e o backend compara com "="; trata como sem unidade
            pa_coduni: String(filters.location ?? '').includes(',') ? '' : filters.location,
            pa_ufmun: city ? city.slice(0, -1) : '',
        });
};

export { shouldEnableQuery, buildRequestFilters };